import StandaloneCta from './StandaloneCta';

export default StandaloneCta;
